/**
 * Home previews the coming week; the page behind its link lists every snoozed relance and every expected one,
 * which the sync projects over its own horizon.
 */
export const HOME_UPCOMING_DAYS = 7;
